import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const TransferRight = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
        <path d="M10.046 7.446a.5.5 0 0 1 .638-.057l.07.057 4.2 4.2a.5.5 0 0 1 .057.638l-.057.07-4.2 4.2a.5.5 0 0 1-.765-.638l.057-.07L13.893 12l-3.847-3.846a.5.5 0 0 1-.057-.638l.057-.07z"/>
      </svg>)} {...props}/>));
export default TransferRight;
